export function getOutlineStyles(outlineColor) {
  return `
      outline: 1px solid ${outlineColor};
      outline: 5px auto -webkit-focus-ring-color;
    `;
}